import { reactive } from 'vue';
import { API_URL } from '../config';

const state =  reactive({
    chosenLinje: 0,
    chosenSize: 0,
    chosenItem: null,
    chosenSizeTitle: "Mellan",
    currentLinjeImage: '',
    defaultLinjeImage: '',
    endpoint: API_URL + "/wp-json/wp/v2/",
    woocommerceEndpoint: API_URL + "/wp-json/wc/v2/",
    optionsEndpoint: API_URL + "/wp-json/acf/v3/options/options", //"http://localhost:8080/options.json", // 
    productPlaceholder: '',
    totalPrice: 0,
    chosenProducts: new Map([]),
    chosenTillval: new Map([]),
    chosenKoksluckor: new Map([]),
    prices: new Map([]),
    sizes: [],
    steps: [],
    itemsHaveLoaded: false,
    numberOfSteps: 0,
    numberOfItemsLoaded: 0,
    optionsLoaded: false,
    proceedButtonLink: "",
    warningText: "",
    numberOfProductsFor2xGrid: [1, 2, 4],
    mixedLinjeId: 32,
    naturalLinjeId: 11,
    tonadLinjeId: 12,
    linjeEndpoint: '',
    tillvalEndpoint: ''
})

const methods = {
    updateStateProducts(product, component, action = false, initialLoadCompleted = true) {
        if (component.$options.name == "Tillval") {
            if (action == "add") {
                state.chosenTillval.set(product.name, product);
            } else if (action == "remove") {
                state.chosenTillval.delete(product.name);
            }
        }
        else {
            if (action == "add") {
                if (component.$options.name == "Linje") {
                    state.chosenKoksluckor.set(product.title.rendered, product);
                } else {
                    state.chosenProducts.set(component.endpoint, product);
                }
            } else if (action == "remove") {
                if (component.$options.name == "Linje") {
                    state.chosenKoksluckor.delete(product.title.rendered);
                } else {
                    state.chosenProducts.delete(component.endpoint);
                }
            }
        }
        this.calculateTotalPrice();
        this.updateLocalStorage(action, component, initialLoadCompleted);
    },
    chooseProduct(product, component, tillvalQuantity = 0, initialLoadCompleted = true) {
        if (component.$options.name == "Tillval" || component.$options.name == "Linje") {
            if (component.chosenProductIds.includes(product.id, 0)) {
                let productIdIndex = (element) => element == product.id;
                let productIndex = component.chosenProductIds.findIndex(productIdIndex);
                component.chosenProductIds.splice(productIndex, 1);
                if (component.$options.name == "Tillval") {
                    if (tillvalQuantity > 0) {
                        product.itemCounter = tillvalQuantity;
                    } else {
                        product.itemCounter = 0;
                    }
                }
                component.updateChosenProductCheckmark("remove");
                this.updateStateProducts(product, component, "remove", initialLoadCompleted);
            } else {
                if (component.$options.name == "Tillval") {
                    component.chosenProductIds.push(product.id);
                    if (tillvalQuantity > 0) {
                        product.itemCounter = tillvalQuantity;
                    } else {
                        product.itemCounter = 1;
                    }
                    component.updateChosenProductCheckmark("add");
                    this.updateStateProducts(product, component, "add", initialLoadCompleted);
                } else {
                    if (state.chosenLinje.id == state.mixedLinjeId) {
                        if (component.chosenProductIds.length != 2) {
                            component.chosenProductIds.push(product.id);
                            component.updateChosenProductCheckmark("add");
                            this.updateStateProducts(product, component, "add", initialLoadCompleted);
                        }
                    } else {
                        component.chosenProductIds = [product.id];
                        component.updateChosenProductCheckmark("add");
                        state.chosenKoksluckor.clear();
                        this.updateStateProducts(product, component, "add", initialLoadCompleted);
                    }
                }
                
            }
        }
        else {
            if (component.chosenProductId == product.id) {
                component.chosenProductId = '';
                component.updateChosenProductCheckmark("remove");
                this.updateStateProducts(product, component, "remove");
            } else {
                component.chosenProductId = product.id;
                component.updateChosenProductCheckmark("add");
                this.updateStateProducts(product, component, "add");
            }
        }
    },
    fetchProductData(endpoint) {
        let fetchedItems;
        return new Promise(resolve => {
            fetch(endpoint + "?per_page=100")
            .then(result => {
                if (result.ok) {
                    return result.json();
                }
                else {
                    throw new Error("Error"); 
                }
            })
            .then(data => {
                if ( data.length > 0 ) {
                    fetchedItems = data;
                } else {
                    fetchedItems = false;
                }
                resolve(JSON.stringify(fetchedItems));
            })
            .catch(err => console.log(err.message + " when calling endpoint: " + state.endpoint + endpoint));
        })
    },
    calculateTotalPrice() {
        let total = 0;
        let currentStep;

        // All normal products
        for (const [key, value] of state.chosenProducts.entries()) {
            for (const stateStep of state.steps) {
                if (stateStep.endpoint == key) {
                    currentStep = stateStep;
                }
            }
            total += (parseFloat(value.acf.product_price) * state.chosenSize * parseFloat(currentStep.prisfaktor));
        }

        // Koksluckor
        if (state.chosenKoksluckor.size > 0) {
            let koksluckeTotal = 0;
            for (const stateStep of state.steps) {
                if (stateStep.productEndpoint != false) {
                    currentStep = stateStep;
                }
            }
            for (const product of state.chosenKoksluckor.values()) {
                koksluckeTotal += (parseFloat(product.acf.product_price) * state.chosenSize * parseFloat(currentStep.prisfaktor));
            }
            total += (koksluckeTotal / state.chosenKoksluckor.size);
        }
        
        // Tillval
        for (const tillval of state.chosenTillval.values()) {
            let currentPrice = parseFloat(tillval.price);
            total += (currentPrice * tillval.itemCounter);
        }

        state.totalPrice = Math.ceil(total);
    },
    getCheckmarkClass(item, component, linje = false, linjeProduct = false, tillvalProduct = false, size = false) {
        let classEnding = "";
        if (linjeProduct) {
            classEnding = component.productImageLayout;
        } else {
            classEnding = component.imageLayout;
        }
        if (linje) {
            if (component.chosenLinjeId == item.id) {
                return "checkmark checkmark__wrapper checkmark__wrapper--" + classEnding;
            } else {
                return '';
            }
        } else if (tillvalProduct) {
            if (component.chosenProductIds.includes(item.id)) {
                return "checkmark checkmark__wrapper checkmark__wrapper--" + classEnding;
            } else {
                return '';
            }
        } else if (linjeProduct) {
            if (component.chosenProductIds.includes(item.id)) {
                return "checkmark checkmark__wrapper checkmark__wrapper--" + classEnding;
            } else {
                return '';
            }
        } else if (size) {
            if (component.chosenSize >= item.sizeFrom && component.chosenSize <= item.sizeTo ) {
                return "checkmark checkmark__wrapper checkmark__wrapper--" + classEnding;
            } else {
                return '';
            }
        } else {
            if (component.chosenProductId == item.id) {
                return "checkmark checkmark__wrapper checkmark__wrapper--" + classEnding;
            } else {
                return '';
            }
        }
    },
    getImageClass(classPart, component, linjeProduct = false) {
        let fullClass = "";
        if (linjeProduct) {
            fullClass = classPart + component.productImageLayout;    
        } else {
            fullClass = classPart + component.imageLayout;
        }
        return fullClass;
    },
    getImage(itemId, imageSize, component, linje = false) {
        let imageUrl = "";
        let loopedItems;
        if (linje) {
            loopedItems = component.linjer;
        } else {
            loopedItems = component.items;
        }
            for (const item of loopedItems) {
                if (item.id == itemId) {
                    if (item.acf.featured_image == false) {
                        imageUrl = state.productPlaceholder;
                        break;
                    } else {
                        if (imageSize == "full") {
                            imageUrl = item.acf.featured_image.sizes["jok-medium-square-hard"];
                        } else if (imageSize == "square") {
                            imageUrl = item.acf.featured_image.sizes.thumbnail;
                        } else {
                            imageUrl = store.state.productPlaceholder;
                        }
                        break;
                    }
                }
            }
        return imageUrl;
    },
    updateLinjeImage(linjeImage) {
        if (linjeImage != "") {
            state.currentLinjeImage = linjeImage;
        } else {
            state.currentLinjeImage = state.defaultLinjeImage;
        }
    },
    itemsInLinje(component) {     
        let filteredItems = [];
        if (component.items == false) {
            return '';
        }

        // Filter to only show products from current linje
        if (component.$options.name != "Tillval") { 
            if (state.chosenLinje != 0) {
                for (const item of component.items) {
                    for (const linje of item.linjer) {
                        if (state.chosenLinje.id == linje) {
                            filteredItems.push(item);
                        }
                    }
                }
            } else {
                filteredItems = component.items;
            }
        } else {
            filteredItems = component.items;
        }

        // Add products from storage on page load
        let storageArray = JSON.parse(localStorage.selection);
        // Tillval & koksluckor
        if (component.$options.name == "Tillval" || component.$options.name == "Linje") {
            let endpoint = "";
            if (component.$options.name == "Tillval") {
                endpoint = component.endpoint;
            } else {
                endpoint = component.productEndpoint;
            }
            let numberOfItemsInStorage = storageArray[endpoint].length;
            let currentItemNum = 0;
            let initialLoadCompleted = true;
            for (const itemFromStorage of storageArray[endpoint]) {
                currentItemNum += 1;
                for (const itemFromComponent of component.items) {
                    if (itemFromStorage.id == itemFromComponent.id && !component.chosenProductIds.includes(itemFromStorage.id)) {
                        if (currentItemNum == numberOfItemsInStorage) {
                            initialLoadCompleted = true;
                        } else {
                            initialLoadCompleted = false;
                        }
                        if (component.$options.name == "Tillval") {
                            this.chooseProduct(itemFromComponent, component, itemFromStorage.quantity, initialLoadCompleted)
                        } else {
                            this.chooseProduct(itemFromComponent, component, 1, initialLoadCompleted)
                        }
                    }
                }
            }
        // Other products
        } else {
            if (component.chosenProductId != storageArray[component.endpoint].id) {
                for (const itemFromComponent of filteredItems) {
                    if (itemFromComponent.id == storageArray[component.endpoint].id) {
                        this.chooseProduct(itemFromComponent, component)
                    }
                }
            }
        }

        // Remove products if not in current linje
        if (component.$options.name != "Tillval" && component.$options.name != "Linje") {
            let stepLinjerArray = [];
            if (component.chosenProductId && state.chosenLinje != 0) {
                let currentItem = '';
                for (const item of component.items) {
                    if (item.id == component.chosenProductId) {
                        currentItem = item;
                    }
                }
                if (currentItem != '') {
                    if (currentItem.linjer) {
                        stepLinjerArray = currentItem.linjer;
                        if (!stepLinjerArray.includes(state.chosenLinje.id)) {
                            component.chosenProductId = '';
                            component.updateChosenProductCheckmark("remove");
                            this.updateStateProducts(currentItem, component, "remove");
                        }
                    }
                }
            }
        }

        component.numberOfFilteredItems = filteredItems.length;
        return filteredItems;
    },
    chooseLinje(item, component, shouldPrompt = false, clearKoksluckor = false) {
        if (clearKoksluckor) {
            state.chosenKoksluckor.clear();
            component.chosenProductIds = [];
            this.updateLocalStorage(true, component, true);
        }
        if (shouldPrompt && localStorage.selection) {
            let storageArray = JSON.parse(localStorage.selection);

            let chosenItemsWillBeLost = false;
            let stepLinjerArray = [];
            for (const key of Object.keys(storageArray)) {
                if (key != state.linjeEndpoint && key != state.tillvalEndpoint && key != 'koksluckor') {
                    if (storageArray[key] != null && storageArray[key].hasOwnProperty('linjer')) {
                        stepLinjerArray = storageArray[key].linjer;
                        if (!stepLinjerArray.includes(item.id)) {
                            chosenItemsWillBeLost = true;
                        }
                    }
                }
            }
            if (chosenItemsWillBeLost) {
                if (confirm(state.warningText)) {
                    this.chooseLinjeActions(item, component);
                }
            } else {
                this.chooseLinjeActions(item, component);
            }
        } else {
            this.chooseLinjeActions(item, component);
        }
    },
    chooseLinjeActions(item, component) {
        if (item.id == component.chosenLinjeId) {
            component.chosenLinjeId = 0;
            state.chosenLinje = 0;
            component.filteredItems = this.itemsInLinje(component);
            component.linjeIsChosen = false;
            let chosenProducts = component.items.filter(item => component.chosenProductIds.includes(item.id));
            component.chosenProductIds = [];
            component.updateChosenProductCheckmark("remove");
            for (const product of chosenProducts) {
                this.updateStateProducts(product, component, "remove");
            }
            component.updateRendered();
            this.updateLinjeImage("");
        } else {
            component.chosenLinjeId = item.id;
            state.chosenLinje = item;
            component.filteredItems = this.itemsInLinje(component);
            component.linjeIsChosen = true;
            component.updateChosenProductCheckmark("add");
            for (const linje of component.linjer) {
                if (item.id == linje.id) {
                    if (linje.acf.featured_image != false) {
                        this.updateLinjeImage(linje.acf.featured_image.sizes["full-hd"]);
                    } else {
                        this.updateLinjeImage("");
                    }
                }
            }
        }
        this.updateLocalStorage(true, component, true);
    },
    filterLinje(component) {
        let storageArray = JSON.parse(localStorage.selection);

        // Choose linje based on chosen kökslucka in storage (if linje is not chosen yet)
        if ((storageArray[component.productEndpoint].length == 2 && !storageArray.loadedInitialLinje) || (storageArray.linjer.id == state.mixedLinjeId  && !storageArray.loadedInitialLinje)) {
            for (const linje of component.linjer) {
                if (state.mixedLinjeId == linje.id) {
                    this.chooseLinje(linje, component);
                }
            }
        } else if (storageArray[component.productEndpoint].length == 1 && !storageArray.loadedInitialLinje) {
            for (const linje of component.linjer) {
                if (storageArray[component.productEndpoint][0].linjer[0] == linje.id) {
                    this.chooseLinje(linje, component);
                }
            }
        // Choose linje based on localstorage (if no kökslucka is chosen)
        } else {
            for (const linje of component.linjer) {
                if (storageArray[component.endpoint].id == linje.id && component.chosenLinjeId != storageArray[component.endpoint].id) {
                    this.chooseLinje(linje, component);
                }
            }
        }
        return component.linjer;
    },
    setStepAsLoaded(component) {
        state.numberOfItemsLoaded++;
        if (state.numberOfSteps == state.numberOfItemsLoaded) {
            state.itemsHaveLoaded = true;
        }
    },
    getText(endpoint, textType, isLinjeProduct = false, mixedLinjeId = false) {
        let text = "";
        for (const step of state.steps) {
            // All steps except köksluckor
            if (step.endpoint == endpoint) {
                if (state.chosenLinje == 0) {
                    if (textType == "title") {
                        text = step.title; 
                    } else if (textType == "description") {
                        text = step.description;
                    }
                } else if (isLinjeProduct) {
                    if (textType == "title") {
                        if (mixedLinjeId) {
                            text = step.titles["titel-kokslucka-" + mixedLinjeId];
                        } else {
                            text = step.titles["titel-kokslucka-" + state.chosenLinje.id];
                        }
                    } else if (textType == "description") {
                        if (mixedLinjeId) {
                            text = step.descriptions["beskrivning-koksluckor-" + mixedLinjeId]
                        } else {
                            text = step.descriptions["beskrivning-koksluckor-" + state.chosenLinje.id]
                        }
                    }
                } else {
                    if (textType == "title") {
                        text =  step.titles["linje-" + state.chosenLinje.id];
                    } else if (textType == "description") {
                        text = step.descriptions["linje-" + state.chosenLinje.id]
                    }
                }
                if (text == "") {
                    if (textType == "title") {
                        text = step.title; 
                    } else if (textType == "description") {
                        text = step.description;
                    }
                }
            }
        }
        return text;
    },
    updateLocalStorage(action, component, initialLoadCompleted) {
        let storageArray = JSON.parse(localStorage.selection);
        // Finding the chosen linje and pushing it to storage.
        if (component.$options.name == "Linje") {
            storageArray["loadedInitialLinje"] = true;
            if (state.chosenLinje != 0) {
                storageArray["linjer"] = {
                    id: state.chosenLinje.id,
                    slug: state.chosenLinje.slug,
                    linjer: [],
                    displayName: state.chosenLinje.name,
                    quantity: 1,
                    permalink: state.chosenLinje.link
                };
            } else {
                storageArray["linjer"] = {};
            }
        }

        // Finding all tillval and pushing them to storage. 
        if (component.$options.name == "Tillval" && (initialLoadCompleted || action)) {
            let tillvalsArray = [];
            for (const [key, value] of state.chosenTillval.entries()) {
                let tillval = {
                    id: value.id,
                    slug: value.slug,
                    linjer: value.linjer,
                    displayName: value.name,
                    quantity: value.itemCounter,
                    permalink: value.permalink
                };
                tillvalsArray.push(tillval);
            }
            storageArray[component.endpoint] = tillvalsArray;
        }

        // Finding all koksluckor and pushing them to storage. 
        if (component.$options.name == "Linje" && (initialLoadCompleted || action)) {
            let koksluckorArray = [];
            for (const [key, value] of state.chosenKoksluckor.entries()) {
                let kokslucka = {
                    id: value.id,
                    slug: value.slug,
                    linjer: value.linjer,
                    displayName: value.title.rendered,
                    quantity: 1,
                    permalink: value.link
                };
                koksluckorArray.push(kokslucka);
            }
            storageArray[component.productEndpoint] = koksluckorArray;
        }

        if (component.$options.name == "Choice" && state.chosenItem != null && (initialLoadCompleted || action)) {
            let choice = {
                displayName: state.chosenItem,
            };
            storageArray[component.endpoint] = choice;
        }

        // Finding all productSteps and pushing them to storage.
        let stegWithProducts = [];
        for (const [key, value] of state.chosenProducts.entries()) {
            let steg = {
                id: value.id,
                slug: value.slug,
                linjer: value.linjer,
                displayName: value.title.rendered,
                quantity: 1,
                permalink: value.link
            };
            storageArray[key] = steg;
            stegWithProducts.push(key);
        }

        // Emptying the storageArray if the key should be empty
        if (action == "remove") {
            for (const storageArrayKey of Object.keys(storageArray)) {
                for (const stateStep of state.steps) {
                    if (!stegWithProducts.includes(storageArrayKey) && stateStep.endpoint != state.tillvalEndpoint && stateStep.endpoint != state.linjeEndpoint) {
                        if (stateStep.endpoint == storageArrayKey) {
                            storageArray[storageArrayKey] = {};
                        }
                    }
                }
            }
        }

        storageArray["pris"] = state.totalPrice;
        storageArray["storlekTitle"] = {displayName: state.chosenSizeTitle};
        storageArray["storlek"] = state.chosenSize;
        localStorage.selection = JSON.stringify(storageArray);
    }
}

export default {
    state,
    methods
}